import { centavosParaDecimal } from '@/nucleo/dinheiro';
import { exportarCsv } from '@/ui/exportCsv';

import { formatarCompetenciaNoEixo } from './calculos';
import type { ConsolidadoPorDre, PontoSerieSme } from './tipos';

/**
 * As duas exportações do protótipo, no canto do quadro consolidado: "Por DRE"
 * e "Série temporal". CSV, por `ui/exportCsv` — o mesmo que o relatório fiscal
 * do SOF usa, sem dependência nova.
 *
 * Dinheiro sai em decimal com ponto (`centavosParaDecimal`), não formatado em
 * real: é arquivo para abrir em planilha e somar, não para ler na tela.
 */

const CABECALHOS_POR_DRE = [
  'DRE',
  'Nome',
  'Credenciados',
  'Apontamentos',
  'Devoluções',
  '% Devoluções',
  'Prazo médio (dias)',
  'Medições',
  'Pagas',
  'Alunos',
  'Valor total',
  'Valor pago',
];

function numero(valor: number | null, casas: number): string {
  return valor === null ? '' : valor.toFixed(casas);
}

export function exportarConsolidadoPorDre(linhas: readonly ConsolidadoPorDre[]): void {
  exportarCsv(
    'relatorios-sme-por-dre.csv',
    CABECALHOS_POR_DRE,
    linhas.map((linha) => [
      linha.dreCodigo,
      linha.dreNome,
      String(linha.credenciados),
      String(linha.apontamentos),
      String(linha.devolucoes),
      numero(linha.percentualDevolucao === null ? null : linha.percentualDevolucao * 100, 1),
      numero(linha.prazoMedioDias, 1),
      String(linha.medicoes),
      String(linha.pagas),
      String(linha.alunos),
      centavosParaDecimal(linha.valorCentavos),
      centavosParaDecimal(linha.valorPagoCentavos),
    ]),
  );
}

export function exportarSerieTemporal(pontos: readonly PontoSerieSme[]): void {
  exportarCsv(
    'relatorios-sme-serie-temporal.csv',
    ['Competência', 'Valor', 'Devoluções'],
    pontos.map((ponto) => [
      formatarCompetenciaNoEixo(ponto.competencia),
      centavosParaDecimal(ponto.valorCentavos),
      String(ponto.devolucoes),
    ]),
  );
}
